// extracted by mini-css-extract-plugin
module.exports = {"link":"ldapMessage__link","loading-container":"ldapMessage__loading-container","alert-error":"ldapMessage__alert-error"};